module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSuperHeavyItalic.51398bb.woff";